import styled from 'styled-components'

export const Wrapper = styled.div<{
  width: string,
  justifyContent: string
}>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent};
  align-items: center;
  gap: .3rem;
  width: ${(props) => props.width};
`

export const Text = styled.span<{ fontSize: string }>`
  font-size: ${(props) => props.fontSize};
`
